import { ApiBase } from './api-base';

/**
 * @template R
 * @typedef {import('axios').AxiosResponse<R>} AxiosResponse<R>
 */

export class DivisionApi extends ApiBase {
  getDivisions = () => this.apiClient.sendRequest({
    method: 'GET',
    url: 'divisions/',
  });

  /**
   * Create a new division
   * @param {{ name: string, can_create_projects_from_ui?: boolean }} data
   * @returns {Promise<AxiosResponse<void>>}
   */
  createDivision = (data) => this.apiClient.sendRequest({
    method: 'POST',
    url: 'divisions/',
    data,
  });

  /**
   * Update division name and/or UI project-creation access
   * @param {string} divisionId
   * @param {{ name: string, can_create_projects_from_ui?: boolean }} data
   * @returns {Promise<AxiosResponse<void>>}
   */
  updateDivision = (divisionId, data) => this.apiClient.sendRequest({
    method: 'PUT',
    url: `divisions/${divisionId}`,
    data,
  });

  /**
   * Delete division
   * @param {string} divisionId
   * @returns {Promise<AxiosResponse<void>>}
   */
  deleteDivision = (divisionId) => this.apiClient.sendRequest({
    method: 'DELETE',
    url: `divisions/${divisionId}`,
  });
}

